import {useState,useEffect} from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import useMarketPlaceVerificationStatus from '../../hooks/useMarketPlaceVerificationStatus';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const MarketPlaceAnnouncements = () => {
  const navigate = useNavigate()
   const { isVerified } = useMarketPlaceVerificationStatus();
   const [announcements, setAnnouncements] = useState([]);
        const fetchAnnouncements = async () => {
          try {
            const res = await axios.get(
              `${BASE_URL}/marketplace/university/announcements/public/`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                  "x-api-key": process.env.REACT_APP_X_API_KEY,
                },
              }
            );
            setAnnouncements(res?.data || []);
          } catch (error) {
            console.log("Error while getting profiles", error);
            setAnnouncements([]);
          }
        };
      
        useEffect(() => {
          fetchAnnouncements();
        }, []);
      
  return (
    <div className=" flex flex-col gap-4 flex-1 w-full">
       <section className="
    w-full
    rounded-2xl border border-gray-200
    bg-white
    p-6
    shadow-sm
    transition-all duration-200
    hover:shadow-md
    hover:border-gray-300
  ">
     <div className="flex items-center gap-3 p-4 bg-[#e8f0f7] rounded-xl mb-6">
  <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center flex-shrink-0">
    <svg
  className="w-5 h-5 text-[#0f6abf]"
  fill="none"
  stroke="currentColor"
  viewBox="0 0 24 24"
>
  <path
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0a3 3 0 11-6 0"
  />
</svg>
  </div>
  <div className="flex-1 min-w-0">
  <div className="flex items-center gap-2 flex-wrap">
    <div className="text-sm font-semibold text-gray-900 break-words">
      Announcements
    </div>
    <div className="text-xs text-gray-500 break-words">
      University ↔ Industry
    </div>
  </div>
</div>

</div>
     {
  announcements.map((p, i) => (
    <div
      key={i}
      className="bg-gray-50 border border-gray-200 rounded-xl p-4 mb-4 cursor-pointer hover:border-[#0f6abf] transition-colors"
    >
      <div className="opp-header mb-4">
                  <div className="flex items-center justify-between mb-3">
                    <div className="bg-[#e8f0f7] border border-[#0f6abf] text-[#0f6abf] text-xs font-semibold inline-block rounded-lg py-1 px-3">
                      {p?.university_data ? p?.university_data?.university_name : p?.industry_data?.industry_name}
                    </div>
                    {/* Right: Profile Section */}
                    <div
                      className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity"
                    >
                     
                        <img
                           src={p?.university_data ? p?.university_data?.university_logo : p?.industry_data?.industry_logo}
                    alt="University"
                          className="w-8 h-8 rounded-full object-cover border border-gray-300"
                          onClick={(e)=>{
                         if(isVerified)
                         {
                            e.stopPropagation()
                       navigate(p?.university_data ? `/marketplace/university/${p?.university_data?.id}` : `/marketplace/industry/${p?.industry_data?.id}`)
                         }
                    }}
                        />
                    </div>
                  </div>
                   <div className="text-lg text-gray-900 mb-2 mt-2 font-bold" >
                  {p?.title}  
                </div>
                   <p
  className="text-sm text-gray-600 mt-2 flex-grow"
  dangerouslySetInnerHTML={{ __html: p?.description }}
/>
  <div className="w-full mt-4">
                      {/* Media Preview */}
              {p.announcement_type === "image" && (
                <img
                  src={p.file}
                  alt={p.name}
                  className="w-full h-48 object-cover"
                />
              )}
              {p.announcement_type === "pdf" && (
                <iframe
                  src={`${p.file}#toolbar=0`}
                  title={p.name}
                  className="w-full h-48"
                />
              )}
              {(p.announcement_type === "doc" || p.type === "docx") && (
                <iframe
                  src={`https://docs.google.com/gview?url=${encodeURIComponent(
                    p.file
                  )}&embedded=true`}
                  title={p.name}
                  className="w-full h-48"
                />
              )}
              {p.announcement_type === "video" && (
                <video
                  src={p.file}
                  controls
                  className="w-full h-48 object-cover"
                />
              )}
              {p.announcement_type === "audio" && (
                <div className="w-full h-48 flex items-center justify-center bg-gray-100">
                  <audio src={p.file} controls className="w-full px-4" />
                </div>
              )}
                </div>
                </div>
    </div>
  ))
}
  </section>

    </div>
  )
}

export default MarketPlaceAnnouncements
